module.exports = __webpack_public_path__ + "09e70abbf7f3c8e0a712186b7840f08d.svg";